import { Tooltip } from 'components'
import { InfoIcon } from 'components/Icon'
import { ContactDetailsSection } from 'components/TeacherProfile/ContactDetailsSection'
import { AvgInstructionLengthInput } from 'components/UserInputs'
import { useFormikContext } from 'formik'
import { Flex, Box, Heading, IconButton } from 'theme-ui'
import { TeacherContact, TeacherUpdateFormValues, ViewMode } from 'types'
import {
  TeachingLocationsFormValues,
  TeachingLocationsSection,
} from './TeachingLocationsSection'

export type TeacherDetailsFields =
  | 'contact'
  | 'avgInstructionLength'
  | 'countryCode'
export type TeacherDetailsFormValues = Pick<
  TeacherUpdateFormValues,
  TeacherDetailsFields
> &
  TeachingLocationsFormValues & { contact: TeacherContact }

export const TeacherDetailsSection = ({
  viewMode,
  isDisabledField,
  shouldShowError = () => true,
  switchToEditing,
  startTabIndex,
}: {
  viewMode: ViewMode
  isDisabledField: (fieldName: keyof TeacherDetailsFormValues) => boolean
  shouldShowError?: (fieldName: keyof TeacherDetailsFormValues) => boolean
  switchToEditing: () => void
  startTabIndex: number
}) => {
  const {
    values,
    errors,
    setFieldValue,
    handleBlur,
  } = useFormikContext<TeacherDetailsFormValues>()

  return (
    <>
      <Flex variant={`forms.section.${viewMode}`}>
        <Box>
          <AvgInstructionLengthInput
            name="avgInstructionLength"
            label="Average instruction time"
            value={values.avgInstructionLength}
            setFieldValue={setFieldValue}
            onBlur={handleBlur}
            disabled={isDisabledField('avgInstructionLength')}
            error={
              shouldShowError('avgInstructionLength')
                ? errors.avgInstructionLength
                : undefined
            }
            tabIndex={startTabIndex}
          />
        </Box>
      </Flex>

      <Box variant={`forms.section.header`}>
        <Heading variant="forms.h2" sx={{ display: 'inline-block' }}>
          My contact details
        </Heading>
        <Tooltip
          variant="teacherContactDetails"
          width={240}
          tooltipSx={{ left: 0 }}>
          <IconButton
            type="button"
            variant={`icon.primary`}
            sx={{ outline: 'none' }}>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <ContactDetailsSection
        name="contact"
        contact={values.contact}
        setFieldValue={setFieldValue}
        countryCode={values.countryCode}
        disabled={isDisabledField('contact')}
        viewMode={viewMode}
        error={errors.contact}
        tabIndex={startTabIndex + 1}
      />

      <Box variant={`forms.section.header`}>
        <Heading variant="forms.h2" sx={{ display: 'inline-block' }}>
          Teaching locations
        </Heading>
      </Box>
      <TeachingLocationsSection
        viewMode={viewMode}
        switchToEditing={switchToEditing}
        startTabIndex={startTabIndex + 11}
      />
    </>
  )
}
